<div class="story-posts-container">
  <app-post-list
    [posts]="storyPosts"
    [loading]="storyPostsLoading"
    [feed]="null"
    [viewMode]="localViewMode"
    [user]="user"
    [showPagination]="true"
    [currentPage]="storyPostsCurrentPage"
    [itemsPerPage]="storyPostsItemsPerPage"
    [totalItemsCount]="storyPostsTotalCount"
    (pageChanged)="onStoryPostsPageChanged($event)"
    (itemsPerPageChanged)="onStoryPostsItemsPerPageChanged($event)"
    [disableTools]="true"
    [isStoryMode]="false"
    [customRemovePost]="removeStoryPost"
    [viewConfig]="localViewConfig"
    [showAdvancedSearch]="false"
  >
    <div postListToolbar class="story-posts-toolbar-wrapper">
      <sui-toolbar #tb>
        <!-- Search -->
        <app-search-input
          [placeholder]="'feed-actions.placeholder.search' | translate"
          [value]="searchQuery"
          (inputChanged)="onSearchChanged($event)"
        ></app-search-input>

        <!-- View (toggles / radios) -->
        <sui-button
          class="right-group-start"
          variant="ghost"
          [leadingIcon]="['fas', 'eye']"
          [trailingIcon]="['fas', 'caret-down']"
          [iconOnly]="tb.collapsed()"
          [ariaLabel]="
            tb.collapsed()
              ? ('feed-actions.button.view' | translate)
              : undefined
          "
          [suiTooltip]="
            tb.collapsed()
              ? ('feed-actions.button.view' | translate)
              : ('feed-actions.button.view-tooltip' | translate)
          "
          [suiPopoverTrigger]="viewPanel"
          suiPopoverPlacement="bottom-end"
          [suiPopoverContainer]="popoverContainer()"
          #viewTrigger="suiPopoverTrigger"
          [expanded]="viewTrigger.isOpen()"
        >
          {{ tb.collapsed() ? "" : ("feed-actions.button.view" | translate) }}
        </sui-button>
        <ng-template #viewPanel>
          <div suiPopover class="dropdown-menu view-dropdown-menu">
            @if (tb.collapsed()) {
              <div class="dropdown-heading">
                {{ "feed-actions.button.view" | translate }}
              </div>
            }
            @for (item of viewItems; track item) {
              @if (item.isSeparator) {
                <div class="dropdown-divider"></div>
              }
              @if (item.isTitle) {
                <div class="dropdown-heading">
                  {{ item.text }}
                </div>
              }
              @if (!item.isSeparator && !item.isTitle) {
                <a
                  class="dropdown-item"
                  (click)="
                    item.action?.();
                    $event.preventDefault();
                    $event.stopPropagation()
                  "
                >
                  <span class="dropdown-item-link-col1">
                    <span class="dropdown-item-link-label">
                      @if (item.icon) {
                        <div>
                          <fa-icon [icon]="item.icon"></fa-icon>
                        </div>
                      }
                      <span>{{ item.text }}</span>
                    </span>
                  </span>
                  <span class="dropdown-item-link-col2">
                    @if (item.isToggle) {
                      <input type="checkbox" [checked]="item.isSelected" />
                    }
                    @if (item.isRadio) {
                      <input
                        type="radio"
                        [name]="item.radioGroup"
                        [checked]="item.isSelected"
                      />
                    }
                  </span>
                </a>
              }
            }
          </div>
        </ng-template>

        <!-- Sort (field radios + order radios) -->
        <sui-button
          variant="ghost"
          [leadingIcon]="
            sortDirection === 'asc'
              ? ['fas', 'arrow-up-a-z']
              : ['fas', 'arrow-down-z-a']
          "
          [trailingIcon]="['fas', 'caret-down']"
          [iconOnly]="tb.collapsed()"
          [ariaLabel]="
            tb.collapsed()
              ? ('feed-actions.button.sort' | translate)
              : undefined
          "
          [suiTooltip]="
            tb.collapsed()
              ? ('feed-actions.button.sort' | translate)
              : ('feed-actions.button.sort-tooltip' | translate)
          "
          [suiPopoverTrigger]="sortPanel"
          suiPopoverPlacement="bottom-end"
          [suiPopoverContainer]="popoverContainer()"
          #sortTrigger="suiPopoverTrigger"
          [expanded]="sortTrigger.isOpen()"
        >
          {{ tb.collapsed() ? "" : ("feed-actions.button.sort" | translate) }}
        </sui-button>
        <ng-template #sortPanel>
          <div suiPopover class="dropdown-menu">
            @if (tb.collapsed()) {
              <div class="dropdown-heading">
                {{ "feed-actions.button.sort" | translate }}
              </div>
            }
            @for (item of sortFieldItems; track item) {
              <a
                class="dropdown-item"
                (click)="
                  onSortFieldChange(item.value);
                  $event.preventDefault();
                  $event.stopPropagation()
                "
              >
                <span class="dropdown-item-link-col1">
                  <span class="dropdown-item-link-label">
                    @if (item.icon) {
                      <div>
                        <fa-icon [icon]="item.icon"></fa-icon>
                      </div>
                    }
                    <span>{{ item.text }}</span>
                  </span>
                </span>
                <span class="dropdown-item-link-col2">
                  <input
                    type="radio"
                    name="story-sort"
                    [checked]="sortField === item.value"
                  />
                </span>
              </a>
            }
            <div class="dropdown-divider"></div>
            @for (item of sortOrderItems; track item) {
              <a
                class="dropdown-item"
                (click)="
                  onSortOrderChange(item.value);
                  $event.preventDefault();
                  $event.stopPropagation()
                "
              >
                <span class="dropdown-item-link-col1">
                  <span class="dropdown-item-link-label">
                    @if (item.icon) {
                      <div>
                        <fa-icon [icon]="item.icon"></fa-icon>
                      </div>
                    }
                    <span>{{ item.text }}</span>
                  </span>
                </span>
                <span class="dropdown-item-link-col2">
                  <input
                    type="radio"
                    name="story-sort-order"
                    [checked]="sortDirection === item.value"
                  />
                </span>
              </a>
            }
          </div>
        </ng-template>
      </sui-toolbar>
    </div>
  </app-post-list>
</div>
